import { createContext, useState } from "react";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";
export const NotificationContext = createContext();

const DashboardLayout = () => {
  const [railNav, setRailNav] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [flooringCount, setFlooringCount] = useState(0);

  return (
    <div
      className={`dashboard_view relative max-[991px]:flex-wrap flex relative`}
    >
      <NotificationContext.Provider
        value={{
          notificationCount,
          setNotificationCount,
          flooringCount,
          setFlooringCount,
        }}
      >
        <SideBar SideBar={(state) => setRailNav(state)} />
        <div className="min-[991px]:pl-[50px] w-full">
          <Outlet />
        </div>
      </NotificationContext.Provider>
    </div>
  );
};

export default DashboardLayout;
